import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '~/components/app-shell'
import { OrganizationSettings } from '~/components/organization-settings'
import { SettingsNav } from '~/components/settings-nav'

export const Route = createFileRoute('/_authed/app/settings/organization')({
  head: () => ({ meta: [{ title: `${m.settings_org_title()} – ${m.app_name()}` }] }),
  component: OrganizationSettingsPage,
})

function OrganizationSettingsPage() {
  const { session } = Route.useRouteContext()
  return (
    <>
      <SettingsNav />
      <PageHeader title={m.settings_org_title()} />
      <OrganizationSettings session={session} />
    </>
  )
}
